import { useEffect, RefObject, DependencyList } from 'react'

export function useSyncHeights(
  refs: RefObject<HTMLElement>[],
  deps: DependencyList = [],
  tolerance = 1
) {
  const recalculate = () => {
    refs.forEach(ref => {
      if (ref.current) {
        ref.current.style.minHeight = ''
      }
    })
    const rects = refs.map((ref, idx) => {
      if (ref.current) {
        return { idx, rect: ref.current.getBoundingClientRect(), ref }
      }
      return { idx, rect: null, ref }
    })
    const groups: Record<number, number[]> = {}
    rects.forEach(({ idx, rect }) => {
      if (!rect) return
      let found = false
      for (const topStr in groups) {
        const top = parseFloat(topStr)
        if (Math.abs(rect.top - top) <= tolerance) {
          groups[top].push(idx)
          found = true
          break
        }
      }
      if (!found) {
        groups[rect.top] = [idx]
      }
    })
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(groups).forEach(([groupKey, indices]) => {
      let tallest = -Infinity
      indices.forEach(i => {
        const rect = rects[i].rect
        if (rect && rect.height > tallest) tallest = rect.height
      })
      indices.forEach(i => {
        const { ref, rect } = rects[i]
        if (ref.current && rect) {
          ref.current.style.minHeight = tallest + 'px'
        }
      })
    })
  }
  useEffect(() => {
    recalculate()
    window.addEventListener('resize', recalculate)
    return () => {
      window.removeEventListener('resize', recalculate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
